namespace TabAurous.Inventory {
    export namespace StockAllocationItemsBOMService {
        export const baseUrl = 'StockAllocation/StockAllocationItemsBOM';

        export declare function Create(request: Serenity.SaveRequest<StockAllocationItemsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<StockAllocationItemsBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<StockAllocationItemsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockAllocationItemsBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "StockAllocation/StockAllocationItemsBOM/Create",
            Update = "StockAllocation/StockAllocationItemsBOM/Update",
            Delete = "StockAllocation/StockAllocationItemsBOM/Delete",
            Retrieve = "StockAllocation/StockAllocationItemsBOM/Retrieve",
            List = "StockAllocation/StockAllocationItemsBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>StockAllocationItemsBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
